<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.606 3.27001L14.056 2.56101C14.725 2.23401 15.534 2.49601 15.883 3.15501L16.64 4.58101C16.84 4.95701 17.202 5.22001 17.622 5.29401L19.212 5.57301C19.946 5.70201 20.445 6.38901 20.341 7.12701L20.115 8.72501C20.055 9.14701 20.194 9.57301 20.49 9.87901L21.612 11.039C22.13 11.574 22.13 12.424 21.612 12.96L20.49 14.12C20.194 14.426 20.055 14.852 20.115 15.274L20.341 16.872C20.445 17.61 19.946 18.297 19.212 18.426L17.622 18.705C17.202 18.779 16.84 19.042 16.64 19.418L15.883 20.844C15.534 21.502 14.726 21.765 14.056 21.438L12.606 20.729C12.223 20.542 11.776 20.542 11.393 20.729L9.94301 21.438C9.27401 21.765 8.46501 21.503 8.11601 20.844L7.36001 19.418C7.16001 19.042 6.79801 18.779 6.37801 18.705L4.78801 18.426C4.05401 18.297 3.55501 17.61 3.65901 16.872L3.88501 15.274C3.94501 14.852 3.80601 14.426 3.51001 14.12L2.38801 12.96C1.87001 12.425 1.87001 11.575 2.38801 11.039L3.51001 9.87901C3.80601 9.57301 3.94501 9.14701 3.88501 8.72501L3.66001 7.12701C3.55501 6.39001 4.05501 5.70201 4.78901 5.57401L6.37901 5.29501C6.79801 5.22101 7.16001 4.95801 7.36001 4.58201L8.11701 3.15601C8.46601 2.49801 9.27401 2.23501 9.94401 2.56201L11.394 3.27101C11.776 3.45801 12.224 3.45801 12.606 3.27001Z"
      :stroke="clr ? clr : `#500FE9`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.375 16H8.625C8.073 16 7.625 15.552 7.625 15V11.376C7.625 10.824 8.073 10.376 8.625 10.376H15.374C15.926 10.376 16.374 10.824 16.374 11.376V15C16.374 15.552 15.926 16 15.375 16Z"
      :stroke="clr ? clr : `#500FE9`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.067 10.381C12.621 10.381 13.764 10.201 14.491 9.44201C15.026 8.88301 15.026 7.97801 14.491 7.41901C13.956 6.86001 13.088 6.86001 12.553 7.41901C11.734 8.27501 12.067 10.381 12.067 10.381V10.381Z"
      :stroke="clr ? clr : `#500FE9`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.933 10.381C11.379 10.381 10.236 10.201 9.50898 9.44201C8.97398 8.88301 8.97398 7.97801 9.50898 7.41901C10.044 6.86001 10.912 6.86001 11.447 7.41901C12.266 8.27501 11.933 10.381 11.933 10.381V10.381Z"
      :stroke="clr ? clr : `#500FE9`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 10.38V16"
      :stroke="clr ? clr : `#500FE9`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
